import { Card } from "@/components/ui/card";
import { Brain, Heart, Sun, Moon, Activity, Calendar } from "lucide-react";

export const FamilyMonitoring = () => {
  const wellnessMetrics = [
    {
      title: "Daily Wellness",
      icon: Heart,
      metrics: [
        { label: "Sleep Quality", value: "7.5 hrs" },
        { label: "Mood", value: "Positive" },
        { label: "Activity Level", value: "Moderate" }
      ]
    },
    {
      title: "Brain Health",
      icon: Brain,
      metrics: [
        { label: "Memory Games", value: "3 completed" },
        { label: "Brain Training", value: "2 sessions" },
        { label: "Daily Goals", value: "85% complete" }
      ]
    },
    {
      title: "Lifestyle",
      icon: Sun,
      metrics: [
        { label: "Social Time", value: "2 hrs today" },
        { label: "Relaxation", value: "45 mins" },
        { label: "Hydration", value: "6 glasses" }
      ]
    }
  ];

  const supportMetrics = [
    {
      title: "Support Network",
      icon: Calendar,
      details: [
        "Next Care Team Meeting: Tomorrow",
        "Family Check-in: Today",
        "Community Event: Thursday"
      ]
    },
    {
      title: "Daily Living",
      icon: Activity,
      details: [
        "Morning Routine: Completed",
        "Medications: On Schedule",
        "Self-Care: Excellent"
      ]
    },
    {
      title: "Rest & Recovery",
      icon: Moon,
      details: [
        "Evening Routine Started",
        "Relaxation Exercise Done",
        "Sleep Schedule On Track"
      ]
    }
  ];

  return (
    <div className="space-y-8 animate-fade-in px-4 py-6">
      <div className="grid gap-8">
        {wellnessMetrics.map((section, index) => (
          <Card 
            key={index} 
            className="p-8 bg-white shadow-lg rounded-2xl border border-gray-100 hover:shadow-xl transition-shadow duration-300"
          >
            <div className="flex items-center gap-5 mb-6">
              <div className="p-4 rounded-xl bg-[#F1F0FB] text-primary">
                <section.icon className="w-8 h-8" />
              </div>
              <h3 className="text-2xl font-semibold text-[#1d1d1f] tracking-tight">
                {section.title}
              </h3>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              {section.metrics.map((metric, idx) => (
                <div 
                  key={idx} 
                  className="p-5 rounded-xl bg-[#F5F5F7] hover:bg-[#F1F0FB] transition-colors duration-200"
                >
                  <p className="text-base text-[#1d1d1f] mb-2 font-medium">{metric.label}</p>
                  <p className="text-xl font-semibold text-[#1d1d1f]">{metric.value}</p>
                </div>
              ))}
            </div>
          </Card>
        ))}

        <div className="grid md:grid-cols-3 gap-6">
          {supportMetrics.map((section, index) => (
            <Card 
              key={index} 
              className="p-8 bg-white shadow-lg rounded-2xl border border-gray-100 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-center gap-5 mb-6">
                <div className="p-4 rounded-xl bg-[#F1F0FB] text-primary">
                  <section.icon className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-semibold text-[#1d1d1f] tracking-tight">
                  {section.title}
                </h3>
              </div>
              <ul className="space-y-4">
                {section.details.map((detail, idx) => (
                  <li 
                    key={idx} 
                    className="text-base text-[#1d1d1f] py-3 px-4 rounded-lg bg-[#F5F5F7] hover:bg-[#F1F0FB] transition-colors duration-200 font-medium"
                  >
                    {detail}
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};